import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrackingComponent } from './tracking/tracking.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

const routes: Routes = [
  // { path: '/:no', component: TrackingComponent },
  { path: 'track', component: TrackingComponent }
];

@NgModule({
  declarations: [TrackingComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule.forRoot(routes, { useHash: true }),
    FormsModule,
  ],
  exports: [RouterModule]
})
export class RoutesModule { }
